import React from "react";
import Select from "react-select";
import { withTranslation } from "react-i18next";
import { officePolicyStatusOptions } from "constants";

const StatusFilter = ({ status, setStatus }) => (
  <Select
    className="react-select-container"
    classNamePrefix="react-select"
    options={officePolicyStatusOptions}
    value={status}
    onChange={(value) => setStatus(value)}
  />
);

export default withTranslation()(StatusFilter);
